export default class Business {
  /**
   * @type {number}
  */
  id;

  /**
   * @type {number}
  */
  officeId;

  /**
   * @type {string}
  */
  businessName;

  /**
   * @type {string}
  */
  repName;

  /**
   * @type {numbstringer}
  */
  stateId;

  /**
   * @type {string}
  */
  address;

  /**
   * @type {string}
  */
  city;

  /**
   * @type {string}
  */
  state;

  /**
   * @type {string}
  */
  zip;

  /**
   * @type {string}
  */
  email;

  /**
   * @type {string}
  */
  phone;

  /**
   * @type {boolean}
  */
  text_optin = true;

  /**
   * @type {string}
  */
 leadSource;

  /**
   * @type {string}
  */
  dateAdded;

  /**
   * @type {string}
  */
  rafCode;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.businessName != null) {
        this.businessName = opts.businessName;
      }
      if (opts.repName != null) {
        this.repName = opts.repName;
      }
      if (opts.stateId != null) {
        this.stateId = opts.stateId;
      }
      if (opts.address != null) {
        this.address = opts.address;
      }
      if (opts.city != null) {
        this.city = opts.city;
      }
      if (opts.state != null) {
        this.state = opts.state;
      }
      if (opts.zip != null) {
        this.zip = opts.zip;
      }
      if (opts.email != null) {
        this.email = opts.email;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.text_optin != null) {
        this.text_optin = opts.text_optin;
      }
      if (opts.leadSource != null) {
        this.leadSource = opts.leadSource;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
      if (opts.rafCode != null) {
        this.rafCode = opts.rafCode;
      }
    }
  }
}
